let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3LPKj")).then(() => parcelRequire('at19N'));